<template>
  <div>
    <h1 class="mb-6 font-bold text-3xl">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('bank.index')">
        Bank
      </inertia-link>
      <span class="text-indigo-400 font-medium">/</span> {{ form.name }}
    </h1>
    <trashed-message
      v-if="bank.deleted_at"
      class="mb-6"
      @restore="restore">
      This Bank has been deleted.
    </trashed-message>
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="update">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input
            v-model="form.name"
            :error="form.errors.name"
            class="pr-6 pb-8 w-full lg:w-1/2"
            label="Nama" />
          <text-area-input
            v-model="form.descriptions"
            :error="form.errors.descriptions"
            class="pr-6 pb-8 w-full lg:w-1/2"
            label="Deskripsi" />
        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center">
          <button
            v-if="!bank.deleted_at"
            class="text-red-600 hover:underline"
            tabindex="-1"
            type="button"
            @click="destroy">
            Delete Bank
          </button>
          <loading-button
            :loading="form.processing"
            class="btn-indigo ml-auto"
            type="submit">
            Update Bank
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
import TextAreaInput from '@/Shared/TextAreaInput'
import { useForm, Link } from '@inertiajs/vue2'

export default {
    metaInfo () {
        return {
            title: `${this.form.name}`,
        }
    },
    components: {
        LoadingButton,
        TextInput,
        TrashedMessage,
        TextAreaInput,
        'inertia-link': Link,
    },
    layout: Layout,
    props: {
        bank: Object,
    },
    remember: 'form',
    data () {
        return {
            form: useForm({
                name: this.bank.name,
                descriptions: this.bank.descriptions,
                deleted_at: this.bank.deleted_at,
            }),
        }
    },
    methods: {
        update () {
            this.form.put(
                this.route('bank.update', this.bank.id),
            )
        },
        destroy () {
            if (confirm('Are you sure you want to delete this bank?')) {
                this.form.delete(
                    this.route('bank.destroy', this.bank.id),
                )
            }
        },
        restore () {
            if (confirm('Are you sure you want to restore this bank?')) {
                this.form.put(
                    this.route('bank.restore', this.bank.id),
                )
            }
        },
    },
}
</script>
